<template>
  <div class="abort-action">
    <button class="button is-warning" @click="$emit('onAbort')">
      Abort
    </button>
  </div>
</template>

<script>
export default {
  name: "Abort",

  data() {
    return {};
  },
};
</script>
<style scoped></style>
